// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPostMessagePrioritizationCategoryResponse = objectOf({
  name: string,
  description: maybe(string),
});
